/* eslint-disable @typescript-eslint/naming-convention */
import { DocumentTypeEntity } from '../../distribution/models/distribution-object';
import { ScheduleItem } from '../../shared/scheduling/models';

export class BatchingConfiguration {
    Id: number | null;
    Name: string;
    BatchingKey: string;
    MinutesSinceFirstDocument: number | null;
    MinutesSinceLatestDocument: number | null;
    NoOfDocuments: number;
    DocumentType: DocumentTypeEntity | null;
    ScheduleItem: ScheduleItem | null;
    IsDeleted: boolean;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
  }


